import createAxiosInstance from './axiosConfig';
import { OriginadorDTO } from '../shared/dto/originadorDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/financiamentoOriginadorController');

export default class FinanciamentoOriginadorService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async incluirAlterarFinanciamentoOriginador(idFinanciamento: number | string, listaDTO: OriginadorDTO[]) {
    return await this.axios.post(`/incluirAlterarFinanciamentoOriginador?idFinanciamento=${idFinanciamento}`, listaDTO);
  }

  async listarFinanciamentoOriginador(idFinanciamento: number | string) {
    return await this.axios.get(`/listarFinanciamentoOriginador?idFinanciamento=${idFinanciamento}`);
  }


}